import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    formContainer: {
      maxWidth: 500,
      width: '100%',
      padding: theme.spacing(4),

      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },

      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2, 1.5),
        margin: 0,
        maxWidth: '100%',
        boxShadow: 'none',
      },
    },
    textInput: {
      minWidth: '100%',
      width: '100%',

      '& .MuiInputBase-root': {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(20),
        fontWeight: 700,
        height: 36,
      },

      '& .Mui-disabled': {
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.common.black,
      },

      '& .Mui-error': {
        color: theme.palette.error.main,
        marginLeft: 0,
        marginRight: 0,
      },

      [theme.breakpoints.down('xs')]: {
        minWidth: 'auto',
      },
    },
    rememberMeContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),

      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(0.5),
      },
    },
    controlLabel: {
      color: theme.palette.customGrey.main,
      margin: 0,
      '& span': {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(20),
      },
    },
    checkbox: {
      color: theme.palette.grey[400],
      padding: theme.spacing(1),
    },
    link: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
    },
    actionContainer: {
      marginTop: theme.spacing(1),
    },
    registerContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    gridContainer: {
      minHeight: 'auto',
      justifyContent: 'flex-start',
      gap: theme.spacing(2),

      [theme.breakpoints.down('xs')]: {
        gap: theme.spacing(1.5),
      },
    },
  }),
);
